export enum ConfigurationFormTimeplanErrorsKeys {
  required = 'required',
  startTimeEndTimeOrder = 'startTimeEndTimeOrder',
  startDateEndDateOrder = 'startDateEndDateOrder',
  endDateBeforeToday = 'endDateBeforeToday',
}

export class ConfigurationFormTimeplanErrors {
  public static getEndTimeErrors(): string[] {
    return [
      ConfigurationFormTimeplanErrorsKeys.required,
      ConfigurationFormTimeplanErrorsKeys.startTimeEndTimeOrder,
      ConfigurationFormTimeplanErrorsKeys.startDateEndDateOrder,
      ConfigurationFormTimeplanErrorsKeys.endDateBeforeToday,
    ];
  }
}
